import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import { RECIPIENT, THIRD_PARTY, COLLECT } from '../../../enums/bill-to-party';
import { BillToPartyPropType } from '../../../prop-types/bill-to-party';
import { ProviderAccountPropType } from '../../../prop-types/provider-account';

const messages = defineMessages({
  primary: {
    description: 'shippingAccountColumn.primary',
    defaultMessage: '(Primary)',
    id: 'Gcav8u',
  },
  recipient: {
    description: 'shippingAccountColumn.recipient',
    defaultMessage: 'Recipient',
    id: 'Sm0GxZ',
  },
  thirdParty: {
    description: 'shippingAccountColumn.thirdParty',
    defaultMessage: 'Third Party',
    id: 'N80HW9',
  },
  recipientWithAccount: {
    description: 'shippingAccountColumn.recipientWithAccount',
    defaultMessage: 'Recipient - {billToAccount}',
    id: 'wlvzJ9',
  },
  thirdPartyWithAccount: {
    description: 'shippingAccountColumn.thirdPartyWithAccount',
    defaultMessage: 'Third Party - {billToAccount}',
    id: 'RgckMN',
  },
  collect: {
    description: 'shippingAccountColumn.collect',
    defaultMessage: 'Collect',
    id: 'bvyM1B',
  },
});

const concatNameParts = (messageDescriptor, billToAccount) => {
  if (!billToAccount) {
    return <FormattedMessage {...messageDescriptor} />;
  }
  return <FormattedMessage {...messageDescriptor} values={{ billToAccount }} />;
};

const formatAccountName = (nickname, providerName, accountNumber, isPrimary) => {
  let result = '';
  // todo figure out how to make this handle arabic in a sane way
  if (nickname) {
    result = `${nickname} (${providerName})`;
  } else {
    result = `${providerName}`;
  }
  if (accountNumber) {
    result = `${result} - ${accountNumber}`;
  }
  if (isPrimary) {
    result = <FormattedMessage defaultMessage='{result} (Primary)' description='messages.primary' id='kzDzKq' values={{ result }} />;
  }
  return result;
};

const ShippingAccountColumn = ({ billToParty, providerAccount, billToAccount = '' }) => {
  if (!billToParty && !providerAccount) {
    return null;
  }
  if (!billToParty) {
    return formatAccountName(
      providerAccount.nickname,
      providerAccount.name,
      providerAccount.accountNumber,
      providerAccount.isPrimaryAccount,
    );
  }
  if (billToParty === RECIPIENT) {
    if (billToAccount) {
      return concatNameParts(messages.recipientWithAccount, billToAccount);
    }
    return concatNameParts(messages.recipient);
  }
  if (billToParty === THIRD_PARTY) {
    if (billToAccount) {
      return concatNameParts(messages.thirdPartyWithAccount, billToAccount);
    }
    return concatNameParts(messages.thirdParty);
  }
  if (billToParty === COLLECT) {
    return <FormattedMessage {...messages.collect} />;
  }

  return null;
};

ShippingAccountColumn.propTypes = {
  billToParty: BillToPartyPropType,
  providerAccount: ProviderAccountPropType,
  billToAccount: PropTypes.string,
};

export default React.memo(ShippingAccountColumn);
